import clsx from 'clsx';
import * as React from 'react';

/**
 * Area to drop collections or spaces in it.
 */
export const DropArea = React.forwardRef(
    (
        props: {
            children: React.ReactNode;
            className?: string;

            /**
             * Boolean coming from useDrop in the parent container (basically monitor.isOver())
             */
            dropHovered: boolean;

            /**
             * When user is hovering the elements for a second
             */
            onDropHover?: () => void;
        },
        ref: React.Ref<HTMLDivElement>
    ) => {
        const { children, dropHovered, onDropHover, className, ...rest } = props;
        //
        // Trigger onHover when mouse is over for 2sec
        //
        const onDropHoverRef = React.useRef(onDropHover);
        onDropHoverRef.current = onDropHover;

        const hoverTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);
        React.useEffect(() => {
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
            }

            if (!dropHovered || !onDropHoverRef.current) {
                return;
            }

            hoverTimeoutRef.current = setTimeout(() => {
                if (onDropHoverRef.current) {
                    onDropHoverRef.current();
                }
            }, 800);
        }, [dropHovered, onDropHoverRef]);

        return (
            <div ref={ref} className={clsx('relative flex w-full flex-col', className)} {...rest}>
                {children}
                {dropHovered ? (
                    <div className="pointer-events-none absolute inset-0 rounded border-2 border-primary" />
                ) : null}
            </div>
        );
    }
);
